module.exports = __webpack_public_path__ + "img/legal_products_header_2.e04aeb33.png";